<template>
  <section id="faq" class="section faq-section">
    <div class="faq-motion" v-reveal aria-hidden="true">
      <div class="faq-motion__orbit faq-motion__orbit--one"></div>
      <div class="faq-motion__orbit faq-motion__orbit--two"></div>
      <div class="faq-motion__core">
        <span>?</span>
      </div>
      <div class="faq-motion__bubble faq-motion__bubble--question">?</div>
      <div class="faq-motion__bubble faq-motion__bubble--answer">!</div>
      <div class="faq-motion__card faq-motion__card--top">
        <span></span>
        <strong>FAQ</strong>
      </div>
      <div class="faq-motion__card faq-motion__card--bottom">
        <span></span>
        <strong>Support</strong>
      </div>
    </div>

    <div class="faq-content" v-reveal>
      <div class="section-heading">
        <p class="section-kicker">{{ labels.kicker }}</p>
        <h2>{{ labels.title }}</h2>
      </div>
      <div class="faq-list">
        <details v-for="item in items" :key="item.question">
          <summary>{{ item.question }}</summary>
          <p>{{ item.answer }}</p>
        </details>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FaqSection',
  props: {
    items: {
      type: Array,
      required: true
    },
    labels: {
      type: Object,
      required: true
    }
  }
}
</script>
